import { useMemo } from "react";
import { createApi } from "../lib/api";
import { useWedding } from "../contexts/wedding-context";

export function useApi() {
  const { slug } = useWedding();
  return useMemo(() => createApi(slug), [slug]);
}
